export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "NAME": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
        "NAME_TOOLTIP": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Once the opportunity is created the asset name can't be changed"])},
        "DEVELOPMENT_PHASE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Development phase"])},
        "ASSET_TYPE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type"])},
        "MECHANISM_OF_ACTION": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mechanism of action"])},
        "THERAPEUTIC_AREA": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Therapeutic areas"])},
        "THERAPEUTIC_AREA_DETAIL": {
          "TITLE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Therapeutic area details"])}
        },
        "CLINICAL_INDICATION": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clinical indications"])},
        "TECHNOLOGIES": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Technologies"])},
        "DESCRIPTION": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Description"])},
        "UPDATE_ASSET_CLASSIFICATION": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Edit ", _interpolate(_named("asset")), " classification"])},
        "APPLICATION": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Applications"])},
        "AREAS_OF_INTEREST": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Areas of interest"])},
        "GALENIC_FORM": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Galenic form"])},
        "CATEGORIES": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Categories"])},
        "TECHNOLOGY_TYPE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type"])},
        "STAGE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stage"])},
        "INDICATION": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indications"])},
        "TECHNOLOGY_APPLICATION": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Applications"])}
      }
    }
  })
}
